import type {
  InstagramAccount,
  InstagramAuthInitResponse,
  InstagramOAuthInitInput,
  PublishInstagramPostParams,
} from './types';

import { apiClient } from '~shared/api/createApiClient';
import { ApiError } from '~shared/api/types';

export const initiateInstagramOAuth = (
  pharmacyId: string,
  input: InstagramOAuthInitInput
): Promise<InstagramAuthInitResponse> =>
  apiClient.post<InstagramAuthInitResponse>('/share/ig/oauth', input, {
    pharmacyId,
  });

export const disconnectInstagram = (pharmacyId: string): Promise<void> =>
  apiClient.delete<void>('/share/ig/oauth', { pharmacyId });

export const publishInstagramPost = (
  pharmacyId: string,
  params: PublishInstagramPostParams
): Promise<void> =>
  apiClient.post<void>('/share/ig/post', params, { pharmacyId });

export const getInstagramAccount = async (
  pharmacyId: string
): Promise<InstagramAccount | null> => {
  try {
    return await apiClient.get<InstagramAccount>('/share/ig/accounts', {
      pharmacyId,
    });
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      return null;
    }

    throw error;
  }
};
